export default {
  header: {
    notes: 'Header in login dialog',
    message: 'Welcome to SAM by Sandvik',
  },
  callToSignin: {
    notes: 'Subheader in login dialog',
    message: 'Please sign in',
  },
  username: {
    notes: 'User name label in login form',
    message: 'Username',
  },
  password: {
    notes: 'Password label in login form',
    message: 'Password',
  },
  keepSignedIn: {
    notes: 'Keep me signed in label in login form',
    message: 'Keep me signed in',
  },
  or: {
    notes:
      'Separator word in login form to distinguish between customer and Sandvik users',
    message: 'Or',
  },
  noAccount: {
    notes: "Don't have an account? label for login form",
    message: "Don't have an account?",
  },
  action: {
    signin: {
      notes: 'Sign in action in login form',
      message: 'Sign in',
    },
    forgotPassword: {
      notes: 'Forgot password in login form',
      message: 'I forgot',
    },
    continueWithSandvikAccount: {
      notes: 'Continue with Sandvik account in login form',
      message: 'Continue with Sandvik account',
    },
    requestDemo: {
      notes: 'Request demo action in login form',
      message: 'Request demo',
    },
    openSignin: {
      notes: 'Open signin dialog action',
      message: 'Sign in',
    },
  },
};
